import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes,Navigate } from "react-router-dom";
// import { HashRouter as Router, Routes,  } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';
import Main from './components/Main.js';
import Dashboard from './pages/account/dashboard.js';
import Profile from './pages/account/Profile.js';
import Transactions from './pages/account/Transactions.js';
import { AuthProvider, useAuth } from './context/authContext.jsx';
import DataForm from './pages/account/BuyData.js';
import BuyAirtime from './pages/account/BuyAirtime.js';
import Administrator from './pages/account/Administrator.js';
import Settings from './pages/account/Settings.js';
import Notifications from './pages/account/Notifications.js';
import DataPrices from './pages/account/DataPrices.js';
import AirtimePrices from './pages/account/AirtimePrices.js';
import Users from './pages/account/Users.js';
//start error interception
// import ErrorPopup, { showError } from './components/error.js';
// import axios from 'axios';

// Global Axios Interceptor for Backend Errors
// axios.interceptors.response.use(
//   response => response,
//   error => {
//     if (error.response) {
//       const errorData = error.response.data;
//       let errorMessage = 'An error occurred';
//       if (errorData && errorData.detail) {
//         if (typeof errorData.detail === 'string') {
//             errorMessage = errorData.detail;
//         } else if (Array.isArray(errorData.detail)) {
//             errorMessage = errorData.detail.map(err => `${err.loc[err.loc.length - 1]}: ${err.msg}`).join(', ');
//         }
//       } else if (errorData && errorData.message) {
//         errorMessage = errorData.message;
//       } else {
//         errorMessage = `HTTP Error: ${error.response.status}`;
//       }
//       showError(errorMessage);
//     } else if (error.request) {
//       showError('Network Error: No response received from backend');
//     } else {
//       showError(`Error: ${error.message}`);
//     }
//     return Promise.reject(error);
//   }
// );

// // Global Fetch Interceptor for Backend Errors
// const originalFetch = window.fetch;
// window.fetch = async (...args) => {
//   const [resource] = args;
//   const url = typeof resource === 'string' ? resource : resource?.url;
  
//   try {
//     const response = await originalFetch(...args);
    
//     // Intercept errors from our backend API
//     const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
//     if (!response.ok && url && (url.includes(apiUrl) || url.includes('easyaccess.com.ng') || url.includes('nellobytesystems.com'))) {
//       const clone = response.clone();
//       try {
//         const errorData = await clone.json();
//         let errorMessage = 'Failed to complete transaction';
//         if (errorData.detail) {
//             if (typeof errorData.detail === 'string') {
//                 errorMessage = errorData.detail;
//             } else if (Array.isArray(errorData.detail)) {
//                 errorMessage = errorData.detail.map(err => `${err.loc[err.loc.length - 1]}: ${err.msg}`).join(', ');
//             }
//         } else if (errorData.message) {
//             errorMessage = errorData.message;
//         }
//         showError(errorMessage);
//       } catch (e) {
//         showError(`HTTP Error: ${response.status} ${response.statusText}`);
//       }
//     }
//     return response;
//   } catch (error) {
//     const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
//     if (url && (url.includes(apiUrl) || url.includes('easyaccess.com.ng') || url.includes('nellobytesystems.com'))) {
//       showError(`Network Error: ${error.message}`);
//     }
//     throw error;
//   }
// };
//end error interception

function App() {


    useEffect(() => {
        AOS.init({
            duration: 1200, // Animation duration
            easing: 'ease-in-out', // Animation easing
            offset: 100, // Offset from the trigger point
            once: true, // Whether animation should happen only once
            delay: 100, // Delay before animation starts

        });
        AOS.refresh();
    }, []);

    return ( 
    <AuthProvider>
        {/* <ErrorPopup /> */}
        <Router>
            <Routes>
                <Route path="/" element={<Main />} />
                <Route path='/account' element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/account/profile" element={<ProtectedRoute><Profile/></ProtectedRoute>}/>
                <Route path="/account/transactions" element={<ProtectedRoute><Transactions/></ProtectedRoute>}/>
                <Route path="/account/admin" element={<ProtectedRoute><Administrator/></ProtectedRoute>}/>
                <Route path="/account/buy-data" element={<ProtectedRoute><DataForm/></ProtectedRoute>}/>
                <Route path="/account/buy-airtime" element={<ProtectedRoute><BuyAirtime/></ProtectedRoute>}/>
                <Route path="/account/settings" element={<ProtectedRoute><Settings/></ProtectedRoute>}/>
                <Route path="/account/notifications" element={<ProtectedRoute><Notifications/></ProtectedRoute>}/>
                <Route path="/account/data-prices" element={<ProtectedRoute><DataPrices/></ProtectedRoute>}/>
                <Route path="/account/airtime-prices" element={<ProtectedRoute><AirtimePrices/></ProtectedRoute>}/>
                <Route path="/account/users" element={<ProtectedRoute><Users/></ProtectedRoute>}/>
            </Routes>
        </Router>
    </AuthProvider>
    );
}
function getUserNow(user){
    if (user !== null) {
        user.providerData.forEach((profile) => {
          console.log("Sign-in provider: " + profile.providerId);
          console.log("  Provider-specific UID: " + profile.uid);
          console.log("  Name: " + profile.displayName);
          console.log("  Email: " + profile.email);
          console.log("  Photo URL: " + profile.photoURL);
        });
      }
      
}
        
function ProtectedRoute({ children }) {
    const {  currentUser, userLoggedIn, loading} = useAuth();
    if (loading) return <div className='btn text-center'>Loading...</div>;
    return userLoggedIn ? 
    (getUserNow(currentUser),
    children) : (<Navigate to="/" />);
  }



export default App;